import { render, staticRenderFns } from "./HomeFavorites.vue?vue&type=template&id=08a62800&"
import script from "./HomeFavorites.vue?vue&type=script&lang=js&"
export * from "./HomeFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports